import { borderRadius, borderWidth, margin, padding } from "polished"
import { Badge } from "../atoms/badges"
import { IconAtom } from "../atoms/iconAtom"
import { TextAtom } from "../atoms/TextAtom"
import { ProgressBarComplete } from "../molecule/timeBar"
import { ToggleSwitch } from "../molecule/ToggleSwitch"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { Modal, ModalBody, ModalFooter, ModalTitle } from "./modal"
import { useContext, useEffect, useMemo, useState } from "react"
import { InputForm, SimpleTextAreaForm, TextAreaForm } from "../atoms/input"
import { DropdownButton, MultiSelectDropdown, StandardButton } from "../atoms/buttons"
import { getAPI, postAPI } from "../api/api"
import { set } from "date-fns"
import { Spinner } from "../atoms/spinner"
import { Chip, ChipFilter } from "../molecule/Chip"
import { ToastContext } from "../App"
import { StandardComp } from "../atoms/standardComp"
import { Search } from "../atoms/search"
import { icon } from "../functions/icons"
import { CountryDropdown } from "../molecule/countryDropdown"

export const AILeadModal = ({ visible, dismiss, finished, mode = true, extraData = null }) => {
    const toast = useContext(ToastContext)
    const [leadStatus, setLeadStatus] = useState(!mode)
    const [page, setPage] = useState(1)
    const [searchContext, setSearchContext] = useState("")
    const [isSearching, setIsSearching] = useState(false)
    const [generatedTerms, setGeneratedTerms] = useState([])
    const [metrics, setMetrics] = useState([
        {
            "metric": "employee_count",
            "description": "Aantal werknemers volgens LinkedIn",
            "type": "number_range",
            "options": ["1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10000+"],
            "chosen": []
        },
        {
            "metric": "employee_growth",
            "description": "Groei van werknemers in de afgelopen 12 maanden",
            "type": "percentage_range",
            "options": ["<-10%", "-10% tot 0%", "0-10%", "10-25%", "25-50%", "50%+"],
            "chosen": []
        },
        {
            "metric": "industry",
            "description": "Sector waarin het bedrijf actief is",
            "type": "multi_select",
            "options": ["IT & Software", "Marketing & Reclame", "Financiën", "Gezondheidszorg", "Onderwijs", "Productie", "Retail", "Consultancy", "Logistiek", "Overig"],
            "chosen": []

        },
        {
            "metric": "company_type",
            "description": "Type organisatie",
            "type": "single_select",
            "options": ["Privébedrijf", "Beursgenoteerd bedrijf", "Zelfstandig", "Overheidsinstelling", "Non-profit", "Partnerschap"],
            "chosen": []
        },
        {
            "metric": "headquarters_region",
            "description": "Regio van het hoofdkantoor",
            "type": "multi_select",
            "options": ["Noord-Amerika", "Europa", "Azië", "Zuid-Amerika", "Afrika", "Oceanië"],
            "chosen": []
        },
        {
            "metric": "founded_year",
            "description": "Oprichtingsperiode",
            "type": "year_range",
            "options": ["<1990", "1990-2000", "2001-2010", "2011-2015", "2016-2020", "2021+"],
            "chosen": []
        },
        {
            "metric": "followers",
            "description": "Aantal LinkedIn-volgers",
            "type": "number_range",
            "options": ["<1k", "1k-5k", "5k-10k", "10k-50k", "50k-100k", "100k+"],
            "chosen": []
        },
        {
            "metric": "activity_level",
            "description": "Activiteitsniveau op LinkedIn",
            "type": "single_select",
            "options": ["Inactief", "Maandelijks", "Wekelijks", "Meerdere keren per week", "Dagelijks"],
            "chosen": []
        }
    ])
    const [preview, setPrewiew] = useState({ name: "Bedrijfsnaam", "description": "Hier komt de omschrijving van het bedrijf" })
    const [departments, setDepartments] = useState([
        { "id_department": 1, "label": "Directie /CEO/ Management", "description": "Beheer en leidinggevende functies", "icon": "briefcase", active: false, type_name: "Directie_CEO_Management" },
        { "id_department": 2, "label": "Sales / Groei", "description": "Verkoop en groeistrategieën", "icon": "chart-line", active: false, type_name: "Sales_Groei" },
        { "id_department": 3, "label": "Human Resources / Personeel", "description": "Personeelsbeheer en HR functies", "icon": "simple_users", active: false, type_name: "Human_Resources_Personeel" },
        { "id_department": 4, "label": "Marketing / Communicatie", "description": "Marketingstrategieën en communicatie", "icon": "bullhorn", active: false, type_name: "Marketing_Communicatie" },
        { "id_department": 5, "label": "IT / Development", "description": "Technische ontwikkeling en IT functies", "icon": "code", active: false, type_name: "IT_Development" },
        { "id_department": 6, "label": "Financiën / Administratie", "description": "Financieel beheer en administratieve functies", "icon": "calculator", active: false, type_name: "Financien_Administratie" }
    ])

    const [statusPreview, setStatusPreview] = useState(false)
    const [searchingPreview, setSearchingPreview] = useState(false)
    const [searching, setSearching] = useState(false)
    const [available, setAvailability] = useState({ available: 20, total: 20 })
    const title_value = (!leadStatus) ? "organisatie" : "lead"

    useEffect(() => {
        if (!visible) return
        loadAvailability(leadStatus)
    }, [visible])

    useEffect(() => {
        setLeadStatus(mode)
    }, [mode])
    const switchLeadStatus = (status) => {
        setLeadStatus(status)
        setGeneratedTerms([])
        setPrewiew(null)
        setStatusPreview(false)
        setSearchContext("")
        loadAvailability(status)
    }

    const handleGenerate = async () => {
        if (leadStatus == 0) {
            await generate_company_words()
            return
        }
        await generate_lead_words()
    }
    const generate_company_words = async () => {
        setIsSearching(true)
        console.log("Generating search terms...")
        const query = "api/leads/generate-search-words"
        const body = { "search_context": searchContext }
        console.log("Request body:", body)
        const generate = await postAPI(query, body)
        if (generate.status == "ok") {
            console.log("Generated company search terms:", generate.data)
            setGeneratedTerms(generate.data)

        }
        setIsSearching(false)

    }


    const generate_lead_words = async () => {
        setIsSearching(true)
        console.log("Generating search terms...")
        const query = "api/leads/generate-search-words/leads"
        const body = { "search_context": searchContext }
        console.log("Request body:", body)
        const generate = await postAPI(query, body)
        if (generate.status == "ok") {
            console.log("Generated lead search terms:", generate.data)
            setGeneratedTerms(generate.data)
        }
        setIsSearching(false)
    }
    const generatePreview = async () => {
        setSearchingPreview(true)
        console.log("Generating preview lead...")
        const query = "api/leads/preview-search"
        const body = { "search_term": generatedTerms[0].label }

        const previewLead = await postAPI(query, body)
        if (previewLead.status == "ok") {
            console.log("Generated preview lead:", previewLead.data)
            setPrewiew(previewLead.data)
            setStatusPreview(true)
        }
        setSearchingPreview(false)
    }
    const handleSearch = async () => {
        if (available.available <= 0) return toast.showToast(`Het maandelijkse aantal searches is bereikt.`, 'error')
        if (leadStatus == 0) {
            await handleSearchCompany()
            return
        }
        await handleSearchLead()
    }

    const handleSearchCompany = async () => {
        setSearching(true)
        const query = "api/leads/complete-search-company"
        const copy_metrics = [...metrics]
        const metrics1 = copy_metrics.filter(metric => metric.chosen.length > 0)
        console.log(metrics1)
        const body = { "search_terms": generatedTerms.map(term => term.label)[0], "search_metrics": metrics1 }
        const response = await postAPI(query, body)
        if (response.data) {
            toast.showToast(`${response.data} nieuwe organisatie gevonden`, 'success')
            setSearching(false)
            finished()
            return
        }
        setSearching(false)
     toast.showToast(`We zijn nog even bezig met zoeken...`, 'orange')

    }

    const handleSearchLead = async () => {
        setSearching(true)
        const query = "api/leads/complete-search-leads"
        const body = { "search_terms": departments.filter(term => term.active === true).map((row => row.type_name)) }
        if (extraData) body.id_lead_company = extraData.id_lead_company
        const response = await postAPI(query, body)
        if (response.data) {
            toast.showToast(`${response.data} nieuwe leads gevonden`, 'success')
            setSearching(false)
            finished()
            return
        }
        setSearching(false)
        toast.showToast(`We zijn nog even bezig met zoeken...`, 'orange')

    }

    const loadAvailability = async (status) => {
        const query = status ? `api/leads/available-leads` : `api/leads/available-companies`
        const load = await getAPI(query)
        setAvailability(load.data)
    }

    const handleRemove = (id) => {
        const copy_generated = [...generatedTerms]
        const index = copy_generated.findIndex(row => row.id_word === id)
        const item = copy_generated[index];
        copy_generated.splice(index, 1)
        setGeneratedTerms(copy_generated)
    }

    const handleDismiss = () => {
        dismiss?.();
    };


    const handleSearchOptions = (index) => {
        const copy_departments = [...departments]
        copy_departments[index].active = !copy_departments[index].active
        setDepartments(copy_departments)

    }

    const handleMetricOptions = (index) => {
        const copy_metrics = [...metrics]
        copy_metrics[index].active = !copy_metrics[index].active
        setMetrics(copy_metrics)

    }
    const handleMetric = (index, index2, item) => {
        console.log(index, index2, item)
        const copy_metrics = [...metrics]
        console.log(copy_metrics[index])
        if (copy_metrics[index]?.chosen?.includes(item)) {
            copy_metrics[index].chosen.splice(index2)
            setMetrics(copy_metrics)
            return
        }
        copy_metrics[index].chosen = [...copy_metrics[index].chosen, item]
        setMetrics(copy_metrics)

    }
    return (
        <Modal height={"unset"} visible={visible} dismissable={handleDismiss}>
            <ModalLeadTitle title={title_value} dismiss={dismiss} />
            {page === 1 ?
                <SearchCreator
                    leadStatus={leadStatus}
                    limit={{ "available": available, "title_value": title_value }}
                    switchLeadStatus={switchLeadStatus}
                    searchContext={searchContext}
                    isSearching={isSearching}
                    handleRemove={handleRemove}
                    generatedTerms={generatedTerms}
                    setSearchContext={setSearchContext}
                    statusPreview={statusPreview}
                    searchingPreview={searchingPreview}
                    handleGenerate={handleGenerate}
                    generatePreview={generatePreview}
                    departments={departments}
                    handleSearchOptions={handleSearchOptions}
                    title_value={title_value}
                    preview={preview}

                /> : <MetricCreator pickMetric={handleMetric} handleSearchOptions={handleMetricOptions} metrics={metrics} />}
            <ModalFooter style={{ backgroundColor: "var(--grey-100)", alignItems: "center", justifyContent: "space-between", padding: "1rem" }}>
                {extraData ? <CompanyInfo company={extraData} /> : <CompanyCount leadStatus={leadStatus} />}
                {!searching ?

                    <HorizontalLayout style={{ justifyContent: "space-between" }}>
                        {(page == 2) && <StandardButton
                            style={{fontWeight:"bold"}}
                            className={"leads-search-button"}
                            onClick={() => {
                                setPage(1)
                            }} title={`<`}
                        />}
                        <StandardButton
                            className={"leads-search-button"}
                            onClick={() => {
                                if (page == 2 || title_value == "lead") { handleSearch(); }
                                if (page == 1 && title_value == "organisatie") { setPage(2) }
                            }} title={`Zoek naar ${title_value}s`}
                        /></HorizontalLayout> : <Spinner />}
            </ModalFooter>
        </Modal>
    )
}

const SearchCreator = ({ leadStatus, limit, switchLeadStatus, searchContext, isSearching, handleRemove, generatedTerms, setSearchContext, statusPreview, searchingPreview, handleGenerate, generatePreview, departments, handleSearchOptions, title_value, preview }) => {
    return (
        <ModalBody>

            <HorizontalLayout style={{ width: "unset", justifyContent: "space-between" }}>
                <SwitcherModule status={leadStatus} toggle={switchLeadStatus} />
                <LimitModule title_value={limit.title_value} limit={limit.available} />
            </HorizontalLayout>
            {!leadStatus ?
                <SearchInputModule textValue={searchContext} isSearching={isSearching} setSearchContext={setSearchContext} generateWords={handleGenerate} /> :
                <SearchDepartments
                    departments={departments}
                    handleSearchOptions={handleSearchOptions}
                />
            }
            {!leadStatus && <GeneratedSearchOptions removeOption={handleRemove} options={generatedTerms} />}
            {!leadStatus && <PreviewComp title_value={title_value} lead={preview} preview={statusPreview} searchingPreview={searchingPreview} generatePreview={generatePreview} />}
        </ModalBody>
    )
}
const MetricCreator = ({ metrics, handleSearchOptions, pickMetric }) => {
    return (
        <SearchMetrics
            handleSearchOptions={handleSearchOptions}
            pickMetric={pickMetric}
            metrics={metrics}
        />
    )
}

const SearchMetrics = ({ metrics, handleSearchOptions, pickMetric }) => {
    return (


        <VerticalLayout style={{ width: "unset", gap: "0.2rem", marginTop: "1rem", padding: "1rem", overflow: 'scroll', alignItems: "unset", maxHeight: "20rem" }}>
            {metrics.map((metric, index) => {
                return (
                    <StandardComp
                        onClick={() => handleSearchOptions(index)}
                        style={{ padding: "0.5rem", margin: "0.1rem", borderColor: metric.active && "var(--primary-500)", borderWidth: metric.active && "1.5px", transition: "0.2s", minWidth: "20rem" }}
                        key={metric.id_department}

                        content={
                            <VerticalLayout>
                                <HorizontalLayout style={{ width: "unset", gap: "0.8rem" }}>
                                    <IconAtom iconSize={25} color={"var(--primary-600)"} icon2={metric.icon} />
                                    <VerticalLayout>
                                        <TextAtom style={{ fontWeight: "bold", marginTop: 0 }} title={metric.description} />
                                        {/* <TextAtom style={{ fontWeight: "light", marginTop: 0, fontSize: "0.8rem" }} title={metric.metric} /> */}
                                    </VerticalLayout>
                                </HorizontalLayout>
                                {metric.active && <Metric metric={metric} pickMetric={pickMetric} index={index} key_value={"options"} />}
                                {metric.chosen && <Metric metric={metric} pickMetric={pickMetric} index={index} key_value={"chosen"} />}

                            </VerticalLayout>
                        }
                    />


                )
            }


            )

            }

        </VerticalLayout>)
}


const Metric = ({ metric, pickMetric, index, key_value }) => {
    return (
        <VerticalLayout style={{ marginTop: metric.active && "1rem" }}>
            {metric[key_value].map((option, index2) => {
                return (
                    <StandardComp onClick={() => pickMetric(index, index2, option)}>
                        {/* <TextAtom style={{ fontWeight: "bold", marginTop: 0 }} title={option} /> */}
                        <TextAtom style={{ fontWeight: "light", marginTop: 0, fontSize: "0.8rem" }} title={option} />
                    </StandardComp>
                )
            })}
        </VerticalLayout>

    )
}

const SearchDepartments = ({ departments, handleSearchOptions }) => {

    return (
        <VerticalLayout style={{ width: "unset", gap: "0.2rem", marginTop: "1rem" }}>
            {departments.map((department, index) => {
                return (
                    <StandardComp
                        onClick={() => handleSearchOptions(index)}
                        style={{ padding: "0.5rem", margin: "0.1rem", borderColor: department.active && "var(--primary-500)", borderWidth: department.active && "1.5px", transition: "0.2s" }}
                        key={department.id_department}

                        content={
                            <HorizontalLayout style={{ width: "unset", gap: "0.8rem" }}>
                                <IconAtom iconSize={25} color={"var(--primary-600)"} icon2={department.icon} />
                                <VerticalLayout>
                                    <TextAtom style={{ fontWeight: "bold", marginTop: 0 }} title={department.label} />
                                    <TextAtom style={{ fontWeight: "light", marginTop: 0, fontSize: "0.8rem" }} title={department.description} />
                                </VerticalLayout>
                            </HorizontalLayout>
                        }
                    />


                )
            }


            )

            }

        </VerticalLayout>

    )
}

const CompanyInfo = ({ company }) => {
    return (
        <HorizontalLayout style={{ gap: "0.3rem" }}>
            <TextAtom

                title={`leads zoeken:`}
            />
            <TextAtom
                style={{ fontWeight: "bold" }}
                title={` ${company.name}`}
            /></HorizontalLayout>)
}

const CompanyCount = ({ leadStatus }) => {
    const [available, setAvailabe] = useState(0)
    useEffect(() => {
        loadTotalCompanies()
    }, [])
    const loadTotalCompanies = async () => {
        const query = "api/leads/companies/searchable"
        const load = await getAPI(query)
        setAvailabe(load.data)

    }
    return (
        leadStatus == 1 &&
        <HorizontalLayout style={{ gap: "0.3rem" }}>
            <TextAtom
                style={{ fontWeight: "bold" }}
                title={available}
            />
            <TextAtom

                title={`Bedrijven beschikbaar`}
            /></HorizontalLayout>)
}

const ModalLeadTitle = ({ title, dismiss }) => {
    return (
        <ModalTitle
            hasXmark={true}
            dismissable={dismiss}
            title={
                <HorizontalLayout>
                    <IconAtom color={"var(--primary-600)"} icon2={"robot"} iconSize={40} />
                    <TextAtom style={{ fontWeight: "bold" }}
                        title={`AI ${title} search`}
                    />
                </HorizontalLayout>

            }
        />
    )

}

const LimitModule = ({ limit, title_value }) => {

    return (
        <HorizontalLayout style={{ justifyContent: "flex-end" }}>
            <VerticalLayout style={{ width: "unset" }}>
                <TextAtom
                    style={{ fontSize: "0.8rem", textAlign: "right", color: "var(--grey-700)" }}
                    title={"maandelijkse limieten"}
                />
                <HorizontalLayout style={{ width: "unset", gap: "0.5rem" }}>
                    <ProgressBar
                        progress={((limit.available / limit.total) * 100)}
                    />
                    <TextAtom
                        style={{ fontSize: "0.8rem", textAlign: "right", fontWeight: "bold" }}
                        title={`${limit.available}/${limit.total} ${title_value} beschikbaar`}
                    />
                </HorizontalLayout>
            </VerticalLayout>

        </HorizontalLayout>
    )
}

export const ProgressBar = ({ progress }) => {
    return (
        <div class="progress-bar" style={{ width: "6rem", marginLeft: '6rem', height: "0.4rem", borderRadius: "10rem", backgroundColor: "var(--grey-200)", position: "relative", overflow: "hidden" }}>
            <div class="" style={{ width: `${progress}%`, height: "100%", borderRadius: "10rem", backgroundColor: "var(--primary-600)", position: "absolute", left: 0, top: 0, transition: "width 0.3s ease-in-out" }}></div>
        </div>
    )
}
const SwitcherModule = ({ toggle, status }) => {
    return (
        <HorizontalLayout style={{ backgroundColor: "var(--grey-100)", justifyContent: "space-between", padding: "0.2rem", borderRadius: "0.4rem", width: "max-content" }}>
            <TextAtom onClick={() => toggle(0)} style={{ backgroundColor: (status == 0) && "var(--card-background-color)", paddingLeft: "0.5rem", paddingRight: '0.5rem', cursor: "pointer", paddingTop: "0.3rem", paddingBottom: "0.3rem", borderRadius: "0.3rem", fontSize: "0.7rem", fontWeight: "bold", textAlign: "right" }} title={"Organisaties"} />
            <TextAtom onClick={() => toggle(1)} style={{ backgroundColor: (status == 1) && "var(--card-background-color)", paddingLeft: "0.5rem", paddingRight: '0.5rem', cursor: "pointer", paddingTop: "0.3rem", paddingBottom: "0.3rem", borderRadius: "0.3rem", fontSize: "0.7rem", fontWeight: "bold", textAlign: "right" }} title={"Leads"} />
        </HorizontalLayout>
    )
}

const SearchInputModule = ({ generateWords, setSearchContext, isSearching, textValue, }) => {
    const [country, setCountrys] = useState({ "code": "nl", "land": "Netherlands", "province": "" });
    return (
        <VerticalLayout style={{ padding: 0, margin: 0, marginTop: "1rem", position: "relative" }}>

            <TextAreaForm
                value={textValue}
                typeInput={(text) => setSearchContext(text)}
                textAreaStyle={{ backgroundColor: "var(--grey-100)", boxShadow: "0 1px 3px rgba(0,0,0,0.15)" }}
            />
            <HorizontalLayout style={{ position: "absolute", right: "0.3rem", bottom: "1.3rem", justifyContent: "flex-end" }}>
                <CountryDropdown setCountrys={setCountrys} />
                {isSearching ? <Spinner style={{ position: "absolute", right: "0.3rem", bottom: "1.3rem" }} /> : <StandardButton onClick={generateWords} title={"genereer zoekwoorden"} style={{ padding: "0.5rem" }}></StandardButton>}
            </HorizontalLayout>
        </VerticalLayout>

    )
}

const GeneratedSearchOptions = ({ options, removeOption }) => {
    console.log("Current generated options:", options)
    return (
        <VerticalLayout style={{ gap: "0.4rem" }}>
            <LeadModalTitle icon={"search"} title={"gegenereerde zoektermen"} />
            <HorizontalLayout style={{ gap: "0.5rem", flexWrap: "wrap" }}>
                <ChipFilter
                    size={"medium"}
                    id_name={"id_word"}
                    wrap={true}
                    options={options}
                    onSelect={(id) => removeOption(id)}
                    all_selected={true}
                />
            </HorizontalLayout>
        </VerticalLayout>

    )
}
const LeadModalTitle = ({ title, icon }) => {
    return (
        <HorizontalLayout style={{ alignItems: "center", gap: "0.2rem" }}>
            <IconAtom iconSize={25} style={{ display: "flex" }} color={"var(--primary-600)"} icon2={icon} />
            <TextAtom
                style={{ fontWeight: "bold", fontSize: "0.7rem" }}
                title={title}
            />
        </HorizontalLayout>
    )
}

const SearchOption = ({ title, removeOption }) => {
    return (
        <Chip
            onClick={removeOption}
            badge={"afgerond"}
            label={title}
            rounded={true}
            style={{ borderColor: "var(--primary-100)", cursor: "pointer", fontWeight: "bold", margin: "0.2rem" }}
        />
    )


}

const PreviewComp = ({ lead, preview, generatePreview, searchingPreview, title_value }) => {
    return (


        preview ? <PreviewLead title_value={title_value} lead={lead} preview={preview} /> : <PreviewButton searchingPreview={searchingPreview} generatePreview={generatePreview} title_value={title_value} />
    )
}
const PreviewLead = ({ lead, preview, title_value }) => {
    return (
        <VerticalLayout style={{ gap: "0.5rem" }}>
            <LeadModalTitle title={`${title_value} preview`} icon={"eye"} />
            <HorizontalLayout
                style={{ boxSizing: "border-box", gap: "1rem" }}
                className="card-outline small-standard-padding standard-margin-bottom standard-border standard-rounded"
            >
                <Avatar lead={lead} />
                <VerticalLayout>
                    <TextAtom
                        style={{ fontWeight: "bold" }}
                        title={lead?.name}

                    />
                    <TextAtom
                        title={lead?.description}
                    />

                </VerticalLayout>
            </HorizontalLayout>
        </VerticalLayout>
    )
}

const PreviewButton = ({ generatePreview, searchingPreview, title_value }) => {
    return (
        <VerticalLayout>
            <LeadModalTitle title={`${title_value} preview`} icon={"eye"} />
            <HorizontalLayout
                onClick={generatePreview}
                style={{ boxSizing: "border-box", gap: "1rem", cursor: "pointer" }}
                className="card-outline small-standard-padding standard-margin-bottom standard-border standard-rounded"
            >
                {searchingPreview ?
                    <VerticalLayout style={{ gap: "1rem" }}>

                        <Spinner />
                        <TextAtom
                            style={{ fontSize: "0.8rem", textAlign: "center" }}
                            title={"Bezig met genereren van preview..."}
                        />
                    </VerticalLayout> :
                    <VerticalLayout style={{ gap: "0.5rem" }}>
                        <TextAtom
                            style={{ fontWeight: "bold" }}
                            title={"Genereer een preview"}

                        />
                        <TextAtom
                            style={{ fontSize: "0.8rem" }}
                            title={"Hier kunt u een preview genereren van het bedrijf die gegenereerd zal worden op basis van de zoektermen."}
                        />

                    </VerticalLayout>
                }
            </HorizontalLayout>

        </VerticalLayout>

    )
}

const JobTitleSearch = ({ changeText, generate, isGenerating }) => {
    return (
        <VerticalLayout style={{ marginTop: "1rem", marginBottom: "0.5rem" }}>
            <LeadModalTitle title={`functie titel`} icon={"simple_leads"} />
            <HorizontalLayout style={{ gap: "0.3rem" }}>

                <InputForm
                    typeInput={(text) => changeText(text)}
                    style={{ margin: 0 }} placeholder={"Functie titel vb: Directeur"} />
                {isGenerating ? <Spinner /> : <StandardButton
                    onClick={generate}
                    style={{ margin: 0, height: "2.3rem", padding: 0, marginTop: "0.2rem" }}
                    title={"Genereer zoekwoorden"}
                />}
            </HorizontalLayout>
        </VerticalLayout>



    )
}

const Avatar = ({ lead }) => {
    return (
        <img
            src={`https://ui-avatars.com/api/?name=${lead?.name}&background=random&color=fff`}
            style={{ height: "4rem", width: "4rem" }}
            className="rounded-img"
        />
    )
}



